import { build_mill_millstone_stack, RECIPE as MILL_MILLSTONE_STACK_RECIPE } from './mill_millstone_stack';
import { build_mill_gear_heap, RECIPE as MILL_GEAR_HEAP_RECIPE } from './mill_gear_heap';
import { build_mill_sluice_gate, RECIPE as MILL_SLUICE_GATE_RECIPE } from './mill_sluice_gate';
import { build_mill_flume_trough, RECIPE as MILL_FLUME_TROUGH_RECIPE } from './mill_flume_trough';
import { build_mill_flume_trestle, RECIPE as MILL_FLUME_TRESTLE_RECIPE } from './mill_flume_trestle';
import { build_mill_waterwheel_undershot, RECIPE as MILL_WATERWHEEL_UNDERSHOT_RECIPE } from './mill_waterwheel_undershot';
import { build_mill_waterwheel_overshot, RECIPE as MILL_WATERWHEEL_OVERSHOT_RECIPE } from './mill_waterwheel_overshot';
import { build_mill_grain_sacks, RECIPE as MILL_GRAIN_SACKS_RECIPE } from './mill_grain_sacks';
import { build_mill_hay_bales, RECIPE as MILL_HAY_BALES_RECIPE } from './mill_hay_bales';
import { build_mill_eel_traps, RECIPE as MILL_EEL_TRAPS_RECIPE } from './mill_eel_traps';
import { build_mill_herb_rack, RECIPE as MILL_HERB_RACK_RECIPE } from './mill_herb_rack';
import { build_mill_chaff_pile, RECIPE as MILL_CHAFF_PILE_RECIPE } from './mill_chaff_pile';
import { build_mill_ferry_post, RECIPE as MILL_FERRY_POST_RECIPE } from './mill_ferry_post';
import { build_mill_ferry_raft, RECIPE as MILL_FERRY_RAFT_RECIPE } from './mill_ferry_raft';
import { definePiece } from '../../definePiece';
import type { PieceDefinition } from '../../contract';

/** Default art and named parameter examples for shared review sheets. */
export const MILLRACE_PIECES = {
  mill_waterwheel_overshot: definePiece(MILL_WATERWHEEL_OVERSHOT_RECIPE, build_mill_waterwheel_overshot, {
    clean: {"spokes": 6, "wear": 0, "moss": 0},
    weathered: {"spokes": 10, "wear": 1, "moss": 1},
  }),
  mill_waterwheel_undershot: definePiece(MILL_WATERWHEEL_UNDERSHOT_RECIPE, build_mill_waterwheel_undershot, {
    low_splash: {"paddles": 8, "splash": 0},
    high_splash: {"paddles": 12, "splash": 1},
  }),
  mill_flume_trestle: definePiece(MILL_FLUME_TRESTLE_RECIPE, build_mill_flume_trestle, {
    two_legs: {"legs": 2, "brace": false},
    braced: {"legs": 3, "brace": true},
  }),
  mill_flume_trough: definePiece(MILL_FLUME_TROUGH_RECIPE, build_mill_flume_trough, {
    new: {"wear": 0},
    worn: {"wear": 1},
  }),
  mill_sluice_gate: definePiece(MILL_SLUICE_GATE_RECIPE, build_mill_sluice_gate, {
    closed: {"open": 0, "copper": 0.3},
    open: {"open": 1, "copper": 1},
  }),
  mill_gear_heap: definePiece(MILL_GEAR_HEAP_RECIPE, build_mill_gear_heap, {
    pair: {"gears": 2, "rust": 0},
    rusted: {"gears": 5, "rust": 1},
  }),
  mill_millstone_stack: definePiece(MILL_MILLSTONE_STACK_RECIPE, build_mill_millstone_stack, {
    single: {"stones": 1, "lean": -1},
    stack: {"stones": 3, "lean": 1},
  }),
  mill_grain_sacks: definePiece(MILL_GRAIN_SACKS_RECIPE, build_mill_grain_sacks, {
    few: {"sacks": 3, "spill": 0},
    heap: {"sacks": 6, "spill": 1},
  }),
  mill_hay_bales: definePiece(MILL_HAY_BALES_RECIPE, build_mill_hay_bales, {
    pair: {"bales": 2},
    stack: {"bales": 4},
  }),
  mill_eel_traps: definePiece(MILL_EEL_TRAPS_RECIPE, build_mill_eel_traps, {
    dry: {"traps": 2, "wet": 0},
    soaked: {"traps": 4, "wet": 1},
  }),
  mill_herb_rack: definePiece(MILL_HERB_RACK_RECIPE, build_mill_herb_rack, {
    sparse: {"bundles": 3},
    full: {"bundles": 6},
  }),
  mill_chaff_pile: definePiece(MILL_CHAFF_PILE_RECIPE, build_mill_chaff_pile, {
    tidy: {"scatter": 0},
    windblown: {"scatter": 1},
  }),
  mill_ferry_post: definePiece(MILL_FERRY_POST_RECIPE, build_mill_ferry_post, {
    slack: {"rope": "slack"},
    taut: {"rope": "taut"},
  }),
  mill_ferry_raft: definePiece(MILL_FERRY_RAFT_RECIPE, build_mill_ferry_raft, {
    empty: {"crates": 0},
    laden: {"crates": 3},
  }),
} as const satisfies Record<string, PieceDefinition>;
